import React, { useContext, useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
/* {all css comes in channelRequest.css */
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import axios from "../../../../axios";
import ThreeDotPostPopup from "./ThreeDot_Post_Popup";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CreatePostFirst from "../../Create_Post_screen/CreatePostFirst";
import { IP } from "../../../../internalServer";
import { useSelector } from "react-redux";
import Popup from "reactjs-popup";
import assets from "../../../../assets/assets";
import MemberList from "./MemberList";
import FeedDetail from "../../Feed_Detail/FeedDetail";
import HeaderContext from "../../../../HeaderContext";

const PostImage = ({ post, commentLength }) => {
  const popupRef = useRef(null);
  const { countComment } = useContext(HeaderContext);
  const [postThreedot, setPostThreedot] = useState("");
  const [postLikeClick, setPostLikeClick] = useState(false);
  const [postLlikeCount, setPostLlikeCount] = useState(post?.like_count);
  const currentUser = useSelector((state) => state.user.currentUser);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [postEdit, setPostEdit] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [postId, setPostId] = useState("");
  // const [comments, setComments] = useState([])
  const handleSlideChange = (current) => {
    setCurrentSlide(current + 1);
  };
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    afterChange: handleSlideChange,
    arrows: true,
  };
  useEffect(() => {
    setPostLikeClick(
      post?.likes?.some((user) => user?.userId === currentUser?.id)
    );
  }, [post?.id]);

  const handelPostLike = async () => {
    try {
      await axios.put(`/community/post/like/${post.id}`, {
        user_id: currentUser?.id,
      });
      setPostLlikeCount(
        postLikeClick ? postLlikeCount - 1 : postLlikeCount + 1
      );
      setPostLikeClick(!postLikeClick);
    } catch (error) {
      console.log(error);
    }
  };

  //   const timeHelper = (a) => {
  //     const dateObj = new Date(a);
  //     const userOffset = dateObj.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
  //     const localDate = new Date(dateObj - userOffset); // Convert to local time
  //     console.log(a, localDate)

  //     const day = localDate.getDate();
  //     const month = localDate.getMonth() + 1;
  //     const year = localDate.getFullYear();
  //     const hours = localDate.getHours();
  //     const minutes = localDate.getMinutes();
  //     const seconds = localDate.getSeconds();

  //     const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  //     return outputDateString;
  // };

  const timeHelper = (a) => {
    const dateObj = moment.utc(a).toDate();
    const ISTDateString = moment(dateObj)
      .utcOffset("+05:30")
      .format("YYYY-MM-DD HH:mm:ss");
    return ISTDateString;
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setPostThreedot(false);
    }
  };

  // useEffect(() => {
  //   const getPostComme = async () => {
  //     const data = [];
  //     try {
  //       const res = await axios.get(
  //         `/community/post/${post.id}/comment/get?sortBy=-1`
  //       );
  //       res && setComments((prev) => [...prev, ...data]);

  //     } catch (error) {
  //       console.log("error", error)
  //     }
  //   };
  //   getPostComme()
  // }, [])

  // console.log("comments", comments)
  // const deletedCount = (comments.filter((usecomment) => usecomment.user_id.id === StudentData.id && !usecomment.isDeleted)).length

  const [clickList, setClickList] = useState(false);

  const handleClick = () => {
    // If popup already open for same post, block click
    if (openPopup && postId === post?.id) return;

    // Allow new popup
    setOpenPopup(true);
    setPostId(post?.id);
  };

  return post && post?.community_id ? (
    <>
      <div
        className="post_img_container w-100 mt-4 rounded-4"
        style={{ backgroundColor: "white" }}
      >
        <div className="p-0 flex gap-2" >
          <div className="px-2 py-0 w-20 h-20">
            {
              post?.user_id?.user_type === "Teacher" ?
                (<img
                  src={
                    post?.user_id?.profile_picture
                      ? IP + post?.user_id?.profile_picture.replace(/^\./, "")
                      : post?.user_id?.gender === "M"
                        ? "/images/Teacher_Male.jpg"
                        : post?.user_id?.gender === "F"
                          ? "/images/Teacher_Female.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{ width: "55px", height: "55px", borderRadius: "15%", cursor: "pointer" }}
                  key={post?.user_id?.avatar_profile}
                  onError={(e) => {
                    if (post?.user_id?.gender === "M") {
                      e.target.src = "/images/Teacher_Male.jpg"
                    } else if (post?.user_id?.gender === "F") {
                      e.target.src = "/images/Teacher_Female.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                />) : (<img
                  src={
                    post?.user_id?.profile_picture
                      ? IP + post?.user_id?.profile_picture.replace(/^\./, "")
                      : post?.user_id?.gender === "M"
                        ? post?.user_id?.avatar_profile ? '/images/Boys/' + post?.user_id?.avatar_profile + '.webp'
                          : "/images/Student_boy_pic.png"
                        : post?.user_id?.gender === "F"
                          ? post?.user_id?.avatar_profile ? '/images/Girls/' + post?.user_id?.avatar_profile + '.webp'
                            : "/images/Student_girl_pic.png"
                          : "/images/default image.png"
                  }
                  alt="icon"
                  className=""
                  style={{ width: "40px", height: "40px", borderRadius: "50%", cursor: "pointer" }}
                  key={post?.user_id?.avatar_profile}
                  onError={(e) => {
                    if (post?.user_id?.gender === "M") {
                      e.target.src = post?.user_id?.avatar_profile ? '/images/Boys/' + post?.user_id?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                    } else if (post?.user_id?.gender === "F") {
                      e.target.src = post?.user_id?.avatar_profile ? '/images/Girls/' + post?.user_id?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                    } else {
                      e.target.src = "/images/default image.png"
                    }
                  }}
                />)
            }
          </div>

          <div className="w-[90%] border-2 border-gray-300 px-3 py-2 rounded-lg cursor-pointer">
            <div className="gap-2 mt-1 mb-3 d-flex align-items-center justify-content-center">
              <div className=" aaa">
                <div className=" d-flex justify-content-between  creationDetails" onClick={handleClick}
                >
                  <div>
                    <div className="d-flex align-items-center">
                      {post?.user_id?.user_type === "Teacher" && (
                        <img
                          className="mr-2"
                          src="/images/teacher_icon.svg"
                          alt=""
                        />
                      )}
                      <span className="request_channel_name" >
                        {post?.user_id?.name}
                      </span>
                      {post?.user_id?.user_type === "Student" && (
                        <span className="request_channel_name mr-2">
                          &nbsp;
                          {post?.user_id?.standard?.name} -
                          {post?.user_id?.section?.name}
                        </span>
                      )}
                      <div className="m-0 p-0 post_tags_list d-flex align-items-center">
                        {post?.tags.length > 0 &&
                          post?.tags.map((tag) => (
                            <span className="related_postName mx-1  px-2 py-1">
                              {tag}
                            </span>
                          ))}
                      </div>
                    </div>
                    <div className={`request_created_by mt-2  ${post?.user_id?.user_type === "Teacher" ? 'ml-4' : 'ml-0'}`}>
                      <div className="mb-1">{post?.community_id?.community_name}</div>
                      <div>{moment(timeHelper(post?.created_at)).calendar({
                        sameDay: "[Today] hh:mm a",
                        lastDay: "[Yesterday] hh:mm a",
                        lastWeek: "DD MMM YYYY hh:mm a",
                        sameElse: "DD MMM YYYY hh:mm a",
                      })}</div>
                    </div>
                  </div>
                  {/* {(currentUser?.id === post?.community_id?.created_by?.id ||
                  currentUser?.id === post?.user_id?.id) && (
                    <img
                      className="Post_HR_threedot"
                      src="/images/three dot hr.svg"
                      alt=""
                      onClick={() => setPostThreedot(!postThreedot)}
                    />
                  )} */}
                  {post?.isDeleted ? <div className="delte" style={{ color: "red" }}>*Deleted</div> : <div className="YPst"></div>}
                </div>
              </div>

            </div>
            <div
              onClick={handleClick}
              style={{
                cursor:
                  openPopup && postId === post?.id ? "default" : "pointer",
                pointerEvents:
                  openPopup && postId === post?.id ? "none" : "auto",
                opacity: openPopup && postId === post?.id ? 0.6 : 1,
              }}
            >
              <p
                style={{
                  wordBreak: "break-all",
                  overflowWrap: "break-word",
                }}
                className={`post_description postDesc ${post?.user_id?.user_type === "Teacher" ? 'ml-4' : 'ml-0'}`}
              >
                {post?.description}
              </p>
            </div>

            {
              post?.post_image?.length > 0 && (
                <div
                  className="col-12 mt-3 mb-4 p-0 request_post_image_box w-full"
                >
                  <div className="slider_container postImage">
                    <Slider {...settings}>
                      {post?.post_image?.length > 0 && (
                        post?.post_image?.map((item, idx) => (
                          // <NavLink to={`/feedDetail`} className="link" state={{ post_id: post?.id }}>
                          // </NavLink>
                          <img
                            key={idx}
                            src={`${IP + item}`}
                            className="request_post_image"
                            alt="post_image"
                            style={{
                              backgroundPosition: "center", backgroundSize: "cover",
                              cursor: openPopup ? "default" : "pointer",
                            }}
                            onClick={() => {
                              if (openPopup && postId === post?.id) return;
                              setOpenPopup(true);
                              setPostId(post?.id);
                            }}
                            onError={(e) => {
                              e.target.src = "/images/no-image5.png"
                            }}
                          />
                        ))
                      )}
                    </Slider>
                    {post?.post_image?.length > 1 && (
                      <span className="post_image_count d-flex align-items-center justify-content-center imagePosIndicator">
                        {currentSlide}/{post?.post_image?.length}
                      </span>
                    )}
                  </div>
                </div>
              )
            }

            {/* <span className="ml-2" style={{ fontSize: '12px', color: 'gray', cursor: "pointer" }} onClick={() => setClickList(!clickList)}>{post?.likes[0]?.name} {post?.likes.length > 1 ? 'and others' : 'only'}</span> */}
            <div className=" px-2  mb-3 flex justify-between items-center like_comment_shear ">
              <div className="like_comment_shear_style likesSection w-36">
                {console.log("postLikeClick", postLikeClick)}
                {!postLikeClick ? (
                  <img
                    src={assets.LikeIcon}
                    className="like_shear_img"
                    onClick={handelPostLike}
                    alt=""
                  />
                ) : (
                  <img
                    src={assets.LikeActiveIcon}
                    className="like_shear_img"
                    onClick={handelPostLike}
                    alt=""
                  />
                )}
                <div className="text-[14px] font-semibold mt-1">
                  {postLlikeCount}
                  <span onClick={() => setClickList(!clickList)}> Likes</span>
                </div>

                {/* <Popup
                on="click"
                className="completed_list"
                trigger={
                }
                content={
                  <div className="likeMemberList">
                    <MemberList totalMember={post?.likes} />
                  </div>
                }
                position=" right "
              /> */}
              </div>
              <div
                onClick={handleClick}
                style={{
                  cursor:
                    openPopup && postId === post?.id ? "default" : "pointer",
                  pointerEvents:
                    openPopup && postId === post?.id ? "none" : "auto",
                  opacity: openPopup && postId === post?.id ? 0.6 : 1,
                }}
              >
                <div className="like_comment_shear_style comments">
                  <img
                    src={assets.CommentIcon}
                    className="like_shear_img"
                    alt=""
                  />

                  <div className="text-[14px] font-semibold mt-1">
                    {!post.isDeleted ? countComment : 0}
                    <span className=""> Comments</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {postThreedot && (
          <div ref={popupRef} className="Post_popupBox">
            <ThreeDotPostPopup
              setPostThreedot={setPostThreedot}
              setPostEdit={setPostEdit}
              post_id={post?.id}
              communityId={post?.community_id?.id}
            />
          </div>
        )}
        {postEdit && (
          <CreatePostFirst
            editingMode={true}
            post={post}
            setClickPost={setPostEdit}
            clickPost={postEdit}
          />
        )}

        {clickList && (
          <MemberList totalMember={post?.likes} setClickList={setClickList} />
        )}
      </div>
      {openPopup && (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            height: "100vh",
            width: "100vw",
            backgroundColor: " rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: '1'
          }}
        >
          <div
            className=" p-2 successful_preview_container rounded-2xl shadow position-relative"
            style={{
              width: "60vw",
              height: "90vh",
              display: "flex",
              justifyContent: "start",
              alignItems: "start",
            }}
          >
            <div className="h-full w-full">

              <div
                className="px-2 py-1"
              >

                <div
                  className="flex align-items-center justify-between "
                  onClick={(e) => {
                    setOpenPopup(false);
                    setPostId("");
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <div className="text-lg font-semibold text-blue-950">Post</div>
                  <img
                    src={assets.CrossIcon}
                    alt=""
                    style={{ width: "28px", height: "28px" }}
                    onClick={(e) => {
                      setOpenPopup(false);
                      setPostId("");
                    }}
                  />
                </div>
                <div className="w-full h-full flex items-center justify-center">
                  <FeedDetail post_id={postId} commentLength={commentLength} />
                </div>

              </div>
            </div>
          </div>
        </div>
      )}
    </>
  ) : (
    <>{/* <img className="Loader" src="/gif/Loader.gif" alt="" /> */}</>
  );
};

export default PostImage;
